const csQnaToastMsg = {
  /**
   *  [상품 문의 리스트] 상품 문의 리스트 요청하기
   */
  GET_QNA_LIST_REQUEST_SUCCESS: '상품 문의 리스트 요청하기 성공',
  GET_QNA_LIST_REQUEST_ERROR: '상품 문의 리스트 요청하기 실패',

  /**
   *  [상품 문의 리스트] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_QNA_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 문의 리스트 요청하기 성공',
  GET_QNA_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 문의 리스트 요청하기 실패',

  /**
   *  [상품 문의 상세] 상품 문의 상세 요청하기
   */
  GET_QNA_DETAIL_REQUEST_SUCCESS: '상품 문의 상세 요청하기 성공',
  GET_QNA_DETAIL_REQUEST_ERROR: '상품 문의 상세 요청하기 실패',

  /**
   *  [상품 문의 상세] 상품 문의 상태 변경 요청하기
   */
  CHANGE_QNA_STATUS_REQUEST_SUCCESS: '상품 문의 상태 변경 요청하기 성공',
  CHANGE_QNA_STATUS_REQUEST_ERROR: '상품 문의 상태 변경 요청하기 실패',

  /**
   *  [상품 문의 상세] 상품 문의 비밀글 여부 변경 요청하기
   */
  CHANGE_QNA_SECRET_REQUEST_SUCCESS: '상품 문의 비밀글 여부 변경 요청하기 성공',
  CHANGE_QNA_SECRET_REQUEST_ERROR: '상품 문의 비밀글 여부 변경 요청하기 실패',

  /**
   *  [상품 문의 상세] 상품 문의 답변 작성하기
   */
  REPLY_QNA_DETAIL_REQUEST_SUCCESS: '상품 문의 답변 작성하기 성공',
  REPLY_QNA_DETAIL_REQUEST_ERROR: '상품 문의 답변 작성하기 실패',
};

export default csQnaToastMsg;
